import { categories } from "@/mocks/categories";

interface EventsToolbarProps {
  activeCat: string;
  onCatChange: (slug: string) => void;
  keyword: string;
  onKeywordChange: (value: string) => void;
  resultCount: number;
}

export default function EventsToolbar({
  activeCat,
  onCatChange,
  keyword,
  onKeywordChange,
  resultCount,
}: EventsToolbarProps) {
  const allCats = [{ slug: "all", name: "全部" }, ...categories];

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-wrap gap-2">
          {allCats.map((cat) => {
            const isActive = activeCat === cat.slug;
            return (
              <button
                key={cat.slug}
                type="button"
                onClick={() => onCatChange(cat.slug)}
                className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors duration-200 cursor-pointer ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {isActive && <i className="ri-check-line text-xs" />}
                {cat.name}
              </button>
            );
          })}
        </div>

        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2 focus-within:border-primary-400">
            <span className="w-4 h-4 flex items-center justify-center text-foreground-400">
              <i className="ri-search-line text-sm" />
            </span>
            <input
              value={keyword}
              onChange={(e) => onKeywordChange(e.target.value)}
              type="text"
              placeholder="搜索标题或标签"
              className="w-full sm:w-48 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
            />
            {keyword && (
              <button
                type="button"
                onClick={() => onKeywordChange("")}
                aria-label="清空搜索"
                className="w-4 h-4 flex items-center justify-center text-foreground-400 hover:text-foreground-700 cursor-pointer"
              >
                <i className="ri-close-circle-line text-sm" />
              </button>
            )}
          </div>
          <span className="whitespace-nowrap text-sm text-foreground-500">
            共 <strong className="text-foreground-900">{resultCount}</strong> 个事件
          </span>
        </div>
      </div>
    </div>
  );
}